import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  align-items: center;

  cursor: pointer;
  width: 100%;
  height: 20px;
  text-align: center;

  [class^='svgIconComponent'] {
    width: 23px;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;

  width: 100%;
`;

export const Icon = styled.span`
  display: flex;
  align-items: center;

  height: 20px;
  cursor: pointer;
`;

export const NumberWrapper = styled.div`
  position: relative;
  color: red;
  font-weight: 600;
  text-align: center;
  left: -14px;
  top: 1px;
`;

export default Root;



// WEBPACK FOOTER //
// ./components/learning-journey/help-icon/styled.js